import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

export const canAccessSignalAnalysis = (): boolean => salesSettingsHelper.isHighLevelAccount();
